module.exports = __webpack_public_path__ + "img/1f618.d40251b.svg";